export interface IFundingStatusObject {
    ContractId: number;
    Status: string;
    AmountFinanced: number;
    DisbursementAmount: number;
    DealerReserveAmount: number;
    BulletinNumber: string;
    AuditorName: string;
    AuditorPhoneNumber: {
        PhoneNumber: string;
        Extension: string | number;
    };
    AuditorFaxNumber: {
        PhoneNumber: string;
        Extension: string | number;
    };
    AuditorComments: string;
    StatusDate: string;
    ApplicationNumber: number;
    BusinessName: string;
    PersonName: {
        FirstName: string;
        MiddleInitial: string;
        LastName: string;
    };
    ApplicantAddress: {
        AddressLine1: string;
        AddressLine2: string;
        City: string;
        State: string;
        ZipCode: {
            Country: string;
            Code: number;
            CodeExtension: string;
        };
        Country: string;
    };
    ApplicantHomePhoneNumber: {
        PhoneNumber: string;
        Extension: string;
    };
    ApplicantWorkPhoneNumber: {
        PhoneNumber: string;
        Extension: string;
    };
    FinanceType: string;
    Term: number;
    Vehicle: {
        VehicleType: string;
        Make: string;
        Model: string;
        ModelCode: string;
        Year: number;
        BodyType: string;
        Mileage: number;
        VIN: {
            Number: string;
        };
        VehicleOptions: string;
        Auction: boolean;
        UsedCarValue: string;
    };
    SSN: string;
    DealerId: string;
    MissingItems: IFundingMissingItems | string;
    Key: string;
}

export interface RemittanceInfo {
    RemitanceDescription: string;
    ReserveAmount: number;
    AmountPaid: number;
}
export interface IEFTNotifications {
    RemittanceInformation: RemittanceInfo[];
    DealerReserveLeaseTotal: number;
    FundingLeaseTotal: number;
    DealerReserveNonLeaseTotal: number;
    FundingNonLeaseTotal: number;
    AmountPaidTotal: number;
    ReserveAmountTotal: number;
    BankName: string;
    BankAccount: string;
    OperationDate: string;
}

export interface FundingStatusTableData {
    key: string;
    name: string;
    accountNumber: number;
    status: FundingSearchStatusOptions;
    collateral: string;
    vin: string;
    dateReceived: string;
}

export interface IFundingMissingItems {
    value: IFundingMissingItem | [IFundingMissingItem];
}

export interface IFundingMissingItem {
    Group: string;
    Items: IItem;
    FunderComments: IItem | string;
}

interface IItem {
    value: string | [string];
}

export enum FundingSearchTypes {
    Status = 'STATUS',
    ReceiveInDays = 'RECEIVE_IN_DAYS',
    ApplicantName = 'APPLICANT_NAME',
    AccountNumber = 'ACCOUNT_NUMBER',
    VIN = 'VIN',
    SSN = 'SSN',
}

export enum FundingSearchStatusOptions {
    ReceivedInProcess = 'ReceivedInProcess',
    Withdrawn = 'Withdrawn',
    UnableToFund = 'UnableToFund',
    FundingApproved = 'FundingApproved',
    BookedAndPaid = 'BookedAndPaid',
}

export enum FundingSearchStatusOptionsState {
    ReceivedInProcess = 'StatusSummary.Label.Item.Received',
    Withdrawn = 'StatusSummary.Label.Item.Withdrawn',
    UnableToFund = 'StatusSummary.Label.Item.UnableToFund',
    FundingApproved = 'StatusSummary.Label.Item.Approved',
    BookedAndPaid = 'StatusSummary.Label.Item.Booked',
    AllStatutes = 'Funding.Status.Table.Function.AllStatuses',
}
